import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 40 32"
    {...props}
  >
    <g clipPath="url(#clip0_1506_22242)">
      <path
        d="M14 16C16.1217 16 18.1566 15.1571 19.6569 13.6569C21.1571 12.1566 22 10.1217 22 8C22 5.87827 21.1571 3.84344 19.6569 2.34315C18.1566 0.842855 16.1217 0 14 0C11.8783 0 9.84344 0.842855 8.34315 2.34315C6.84285 3.84344 6 5.87827 6 8C6 10.1217 6.84285 12.1566 8.34315 13.6569C9.84344 15.1571 11.8783 16 14 16ZM11.1438 19C4.9875 19 0 23.9875 0 30.1437C0 31.1687 0.83125 32 1.85625 32H26.1437C26.2563 32 26.3625 31.9875 26.475 31.9688C21.7063 28.525 20.2375 23.1562 20.0312 19.4562C19.025 19.1562 17.9625 19 16.8625 19H11.15H11.1438ZM30.4438 14.1062L22.9438 17.1063C22.375 17.3375 22 17.8875 22 18.5C22 22.4562 23.6188 29.05 30.425 31.8875C30.7938 32.0438 31.2125 32.0438 31.5813 31.8875C38.3813 29.05 40 22.4562 40 18.5C40 17.8875 39.625 17.3375 39.0563 17.1063L31.5563 14.1062C31.2 13.9625 30.8 13.9625 30.4438 14.1062ZM36.9625 19.5C36.7188 22.6687 35.2625 26.7938 31 28.8563V17.1187L36.9625 19.5Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_1506_22242">
        <rect width="40" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
const IconUserShield = forwardRef((props: Omit<IconProps, 'icon'>, ref) => {
  return <Icon ref={ref} icon={Svg} {...props} />;
});
export default IconUserShield;
